import styled from 'styled-components/macro';

const StyledCoursesSectionWrapper = styled.div`
    width: 100%;
    display: flex;
    flex-wrap: wrap;
`;

export default StyledCoursesSectionWrapper;
